export const TOAST_LIMIT = 10000;
export const TOAST_MARGIN = 8;
export const TOAST_MIN_WIDTH = 286
export const TOAST_MIN_HEIGHT = 32
export const TOAST_DEFAULT_DURATION = 3

export const TOAST_SPACE_BOTTOM = (TOAST_MIN_HEIGHT + TOAST_MARGIN + 16);
